import React, { useEffect } from "react";

import Main from '../components/About/Main'
import DiscoverOur from "../components/About/DiscoverOur";
import MoneyWork from "../components/About/MoneyWork";
import Years from "../components/About/Years";
import OurAch from "../components/About/OurAch";
import JoinOver from "../components/About/JoinOver";

function About () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[60px]">
            <Main/>
            <DiscoverOur/>
            <MoneyWork/>
            <Years/>
            <OurAch/>
            <JoinOver/>
        </div>
    );
}

export default About;